import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeDkeyLinearIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M11.646 2.35365L2.35322 11.6464C2.15796 11.8417 2.15796 12.1583 2.35322 12.3536L11.646 21.6464C11.8413 21.8416 12.1579 21.8416 12.3531 21.6464L21.6459 12.3536C21.8412 12.1583 21.8412 11.8417 21.6459 11.6464L12.3531 2.35365C12.1579 2.15839 11.8413 2.15839 11.646 2.35365Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeDkeyLinearIcon.displayName = 'TimeDkeyLinearIcon';
